import React, { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

type TextField2TProps = {
  label?: string;
  value?: string;
  mandatory?: boolean;
  noborder?: boolean;
  type?: string;
  mandatory_length?: number | null;
  mandatory_characters?: string[];
  min?: number;
  max?: number | null;
  onChange?: (e: any) => void;
  className?: string;
  autoComplete?: string;
  transparent?: boolean;
  onEnter?: () => void;
  autofocus?: boolean;
  disabled?: boolean;
  items?: { label: string }[];
  onSuggestedValue?: (value: any) => void;
  can_display?: boolean; // Optional prop to control password visibility
};

function TextField2T(props: TextField2TProps) {
  const {
    label = "",
    value = "",
    mandatory = false,
    noborder = false,
    type = "text",
    min = 0,
    max = null,
    onChange = () => {},
    className = "",
    autoComplete = "off",
    transparent = false,
    onEnter = () => {},
    autofocus = false,
    disabled = false,
    items = [],
    onSuggestedValue = () => {},
    can_display = true, // Optional prop to control password visibility
  } = props;

  const mandatory_length =
    props.mandatory_length !== undefined
      ? props.mandatory_length
      : type === "phone"
      ? 14
      : null;

  const mandatory_characters =
    props.mandatory_characters !== undefined
      ? props.mandatory_characters
      : type === "email"
      ? ["@", "."]
      : [];
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };
  const [autoFilled, setAutoFilled] = useState(false);
  const [hovering, setHovering] = useState(false);
  // Add state for password visibility
  const [passwordVisible, setPasswordVisible] = useState(false);

  useEffect(() => {
    const input = document.getElementById(`input-${label}`);

    if (input) {
      setTimeout(() => {
        input.style.backgroundColor = "white"; // Ensure background resets
        input.style.transition = "background-color 5000s ease-in-out 0s"; // Prevent instant reset
      }, 100);
    }
  }, []);

  const [focus, setFocus] = useState(false);
  const [suggestedValue, setSuggestedValue] = useState<string>("");

  // Add showPassword function to toggle password visibility
  const showPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  // add a listenner to the enter key and if suggestedValue is not empty, call onSuggestedValue with the suggestedValue
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && suggestedValue) {
        onSuggestedValue(suggestedValue);
        setSuggestedValue(""); // Clear suggested value after selection
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [suggestedValue, onSuggestedValue]);

  const handleChange = (ee: any) => {
    let formatted = forceformat(ee.target.value, type);
    let e: any = { ...ee, target: { ...ee.target, value: formatted } };
    onChange(e);

    const found = items.find((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase())
    );

    if (found && e.target.value?.length > 0) {
      setSuggestedValue(found.label as any);
    } else {
      setSuggestedValue("");
    }
  };

  let has_value = value !== null && value !== undefined && value !== "";
  let missing_mandatory_characters = mandatory_characters.some(
    (char) => !value.includes(char) && has_value
  );
  let mandatory_length_disrespect =
    mandatory_length && value?.length !== mandatory_length && has_value;
  let mandatory_disrespect =
    (mandatory && !value && !focus) ||
    missing_mandatory_characters ||
    mandatory_length_disrespect;
  let border_color = mandatory_disrespect
    ? "border-red-300"
    : focus
    ? "border-blue-300"
    : "border-gray-200";

  // Determine the actual input type based on password visibility
  const inputType =
    type === "password" ? (passwordVisible ? "text" : "password") : type;

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      className={`w-full min-h-11 h-11 relative flex flex-row select-none ${
        has_value ? "items-end" : "items-center py-1"
      } text-black ${className} 
      w-full
      px-2  
      
     
      rounded-xl
      ${
        noborder
          ? ""
          : focus
          ? "border-2 outline-1 outline-blue-100"
          : mandatory_disrespect
          ? "border-2 outline-1 outline-red-100"
          : "border    "
      }
      ${border_color}
      
      outline-none
      transition
      ease-in-out
      duration-150
      ${
        disabled
          ? "bg-neutral-100 text-shadow_25"
          : transparent
          ? "bg-transparent font-semibold"
          : "bg-white"
      }      
    `}
    >
      {has_value && (
        <div
          className={`
          
               ${focus ? "text-blue-400 font-medium" : "text-gray-300"}

          absolute top-1 text-h6 `}
        >
          {label}
        </div>
      )}
      {(mandatory_length_disrespect || missing_mandatory_characters) && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ invalide
        </div>
      )}
      {mandatory && !has_value && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ obligatoire
        </div>
      )}
      {!disabled && type != "number" && type != "password" && (
        <div
          onClick={() => handleChange({ target: { value: "" } })}
          className={`absolute bg-neutral-100 rounded-full p-0.5 ${
            hovering && has_value ? "opacity-100" : "opacity-0"
          } cursor-pointer transition duration-300   ease-in-out top-1/3 right-3 text-gray-300 text-h6 `}
        >
          <Icon1
            icon_name="close"
            size={13}
            fill="grey"
            hover_color={"black"}
          />
        </div>
      )}{" "}
      {suggestedValue && (
        <div
          onClick={() => {
            onSuggestedValue(suggestedValue);
          }}
          className={`absolute cursor-pointer hover:bg-blue-50 right-2 h-full flex flex-row gap-2 items-center bg-white justify-center rounded-lg px-2 py-1 text-blue-400 text-h3 `}
        >
          <Icon1 icon_name="entree" size={20} fill="#60a5fa" />
          {suggestedValue}
        </div>
      )}
      {type == "password" && can_display && (
        <div
          onClick={() => showPassword()}
          className={`absolute bg-neutral-100 rounded-full p-0.5 ${
            hovering && has_value ? "opacity-100" : "opacity-0"
          } cursor-pointer transition duration-300   ease-in-out top-1/3 right-3 text-gray-300 text-h6 `}
        >
          <Icon1
            icon_name={passwordVisible ? "eye" : "eye"}
            size={13}
            fill="grey"
            hover_color={"black"}
          />
        </div>
      )}
      <input
        id={`input-${label}`}
        disabled={disabled}
        type={inputType} // Use the dynamically determined type
        min={min}
        max={max !== null ? max : undefined}
        placeholder={label}
        value={value === null ? "" : value}
        autoFocus={autofocus}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        autoComplete={autoComplete}
        className={`
          w-full
          bg-transparent
          rounded-xl
py-1       
          
          outline-none
          transition
          ease-in-out
          duration-150
        `}
        style={{
          fontSize: "14px",
        }}
      />{" "}
    </div>
  );
}

export default TextField2T;

function forceformat(value: string, type: string) {
  if (type === "phone") {
    // Remove all non-numeric characters
    // Add a spaces after every 2 characters
    // Remove any spaces at the end
    // Limit to 14 characters
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})/g, "$1 ")
      .replace(/\s+$/, "")
      .slice(0, 14);
  }
  return value;
}
